// import 'jquery.magnific-popup-update'
import {popupAjaxOptions} from './popup-ajax-options'

const {$} = window
export function popupTicketLinks(src) {
  const magnificPopup = $.magnificPopup.instance
  const opt = popupAjaxOptions(magnificPopup)
  const popupAjaxOpts = Object.assign(opt, {
    mainClass: 'MfpMainFade2',
    callbacks: {
      beforeOpen: () => {
        document.querySelector('body').classList.replace('nav-open', 'modal-frame-is-opened')
        window.scrollTo(0, 0)

        console.info('Start of popup initialization')
      },
      afterClose: () => {
        document.querySelector('body').classList.replace('modal-frame-is-opened', 'nav-open')
        // console.log('Popup is completely closed')
      },
      ajaxContentAdded: () => {
        console.info('Popup closeBtn')
        const closeBtn = '<button title="Close (Esc)" type="button" class="mfp-close"></button>'
        magnificPopup.content.prepend(closeBtn)
      },
    },
  })

  // console.info(`${opt}`)

  // $("[popup-ticket-links='ajax']").magnificPopup({
  //   ...popupAjaxOpts,
  // })
  //
  // $("[popup-content-links='ajax']").magnificPopup({
  //   ...popupAjaxOpts,
  // })
  //
  // $('.PopupContentAjax').magnificPopup({
  //   ...popupAjaxOpts,
  // })

  $.magnificPopup.open(
    {
      items: {
        src,
      },
      ...popupAjaxOpts,
    },
    0
  )
}

window.popupTicketLinks = popupTicketLinks
